export default {
  ADD_ATTR: [ "language" ],
  SAFE_FOR_XML: false,
  RETURN_DOM: true
}
